import { useCallback, useState } from 'react';
import * as THREE from 'three';

export function useModelBounds() {
  const [modelBounds, setModelBounds] = useState<{
    box: THREE.Box3;
    center: THREE.Vector3;
  } | null>(null);

  const handleBoundsComputed = useCallback((box: THREE.Box3, center: THREE.Vector3) => {
    setModelBounds((prev) => {
      if (
        prev &&
        prev.center.distanceToSquared(center) < 0.000001 &&
        prev.box.min.equals(box.min) &&
        prev.box.max.equals(box.max)
      ) {
        return prev;
      }
      return { box: box.clone(), center: center.clone() };
    });
  }, []);

  const resetBounds = useCallback(() => {
    setModelBounds(null);
  }, []);

  return { modelBounds, handleBoundsComputed, resetBounds };
}
